import { schema } from "normalizr";

export const application = new schema.Entity("application");
export const applicationList = [application];
